// extracted by mini-css-extract-plugin
export default {"gray":"#7e8d8a","darkGray":"#404948","light":"#fff","colorSleep":"#359685","colorAxes":"#bccdcb","colorLimitline":"#e5a212"};